/**
 * Validate email
 *
 * @param {String} email
 *
 * @return {boolean}
 */
export default function isEmail (email) {
    if (!email) {
        return null;
    }

    //eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email.trim().toLowerCase()) ? null : 'validation.error.email';
}
